import React, { ChangeEvent, useMemo } from 'react'
import Box from '@mui/material/Box'
import TextField, { TextFieldProps } from '@mui/material/TextField'
import SvgIcon from '@mui/material/SvgIcon'
import Success_filled from '@tdcerhverv/parrotfish/dist/icons/Icons/Success_filled.svg'
import usePropStyles from '../../utils/usePropStyles'
import { useController } from 'react-hook-form'
import ErrorMessage from '../../ErrorMessage'
import PopOverInfo from '../../PopOverInfo'
import { AccountNumberProps } from './types'
import { useTheme } from '@mui/material/styles'
//@ts-ignore
import InputMask, { Props as InputmaskProps } from 'react-input-mask'

export const AccountNumber: React.FC<AccountNumberProps> = ({
  fieldType,
  fieldWidth,
  label,
  required,
  assistiveText,
  control,
  popover,
  disabled,
  mask,
  ...props
}) => {
  const fieldName = props.name!
  const { field, fieldState } = useController({ name: fieldName, control, rules: { required: required! } })
  const hasError = Boolean(fieldState.error)
  const showValidation = required && !hasError && fieldState.isTouched
  const propStyles = usePropStyles(fieldWidth)
  const { ref, onChange, ...fieldProps } = field

  const { palette } = useTheme()
  const styles = useMemo(
    () => ({
      boxStyles: {
        display: 'flex',
        paddingBottom: '24px',
        '& > button': {
          alignSelf: 'baseline',
        },
      },
      inputField: {
        display: 'flex',
        '& > div': {
          '& > input, > textArea ': {
            minWidth: 0,
          },
        },
      },
      successIcon: {
        color: palette.success.main,
        width: '20px',
        height: '20px',
      },
    }),
    [],
  )

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    //remove mask from value
    onChange(event.target.value?.replace(/\s+/g, ''))
  }

  return (
    <Box sx={styles.boxStyles}>
      <InputMask {...props} {...fieldProps} onChange={handleChange} mask={mask} maskChar={null}>
        {(inputProps: InputmaskProps & TextFieldProps) => (
          <TextField
            {...props}
            {...inputProps}
            ref={ref}
            sx={[styles.inputField, propStyles]}
            error={hasError}
            label={label}
            helperText={
              hasError ? (
                <ErrorMessage>
                  <>{fieldState.error?.message}</>
                </ErrorMessage>
              ) : (
                assistiveText
              )
            }
            InputProps={{
              endAdornment: showValidation && (
                <SvgIcon sx={styles.successIcon} component={Success_filled} viewBox="0 0 48 48" />
              ),
            }}
            required={required!}
          />
        )}
      </InputMask>
      {popover && <PopOverInfo {...popover} />}
    </Box>
  )
}
